export interface ApplicationSubmitToPscaResponse {
    applicationId: number;
    submissionStatus: ApplicationSubmitToPscaStatus;
    filingStatus: string;
    message?: string;
}

export enum ApplicationSubmitToPscaStatus {
    Submitted = 1,
    FailedValidation = 2,
}
